export default function() {
  return function(date) {
    if (!date) {
      return '';
    }

    if (typeof date === 'string') {
      const parts = date.split('-');
      return [parts[2], parts[1], parts[0]].join('/');
    }

    if (Object.prototype.toString.call(date) === '[object Date]') {
      const day = (date.getDate() < 10)? `0${date.getDate()}` : date.getDate();
      const month = ((date.getMonth() + 1) < 10)? `0${(date.getMonth() + 1)}` : (date.getMonth() + 1);
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }

    return '';
  };
}



// WEBPACK FOOTER //
// ./client/app/common/filters/slashDate.js